// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__27FJh","tab":"Tabs_tab__3ppjG","tabActive":"Tabs_tabActive__vCYGg"};